// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"cc6e1c23","317":"1b3815f8"}[chunkId] + ".chunk.js";
};